import ReactRenderer from 'modules/_react-renderer'
import { ProductShopWidget } from "app/ProductShop/ProductShopWidget";

ReactRenderer.registerComponent('ProductShopWidget', ProductShopWidget)
ReactRenderer.render()
